import * as React from "react";

import ClassNames from "classnames";
import Styles from "./Accordion.module.css";

import IconRight from "../_assets/icon-chevron-right.svg";

import Typography from "../Typography";

export interface Props {
  className?: string;
  title?: string;
  children?: any;
  id?: string;
  isOpen?: boolean;
  variant?: "h2" | "h3" | "h4" | "h5";
}

const Accordion: React.FC<Props> = props => {
  const {
    className,
    children,
    title,
    id,
    variant = "h3",
    isOpen = false
  } = props;
  const [open, toggleOpen] = React.useState(isOpen);

  function toggleAccordion() {
    toggleOpen(!open);
  }

  return (
    <div className={Styles.wrapper}>
      <details
        className={ClassNames({
          [Styles.details]: true,
          [className]: className
        })}
        aria-expanded={open}
        aria-controls={id}
        open={isOpen}
      >
        <summary className={Styles.summary} onClick={toggleAccordion}>
          <div className={Styles.iconWrapper}>
            <span
              className={ClassNames({
                [Styles.icon]: true,
                [Styles.open]: open
              })}
            >
              {<IconRight is="svg" />}
            </span>
          </div>
          <Typography variant={variant} className={Styles.title}>
            {title}
          </Typography>
        </summary>
        <div className={Styles.content} id={id}>
          {children}
        </div>
      </details>
    </div>
  );
};

export default Accordion;
